import BaseContainer from './components/baseContainer/index.vue'
import BuyFeature from './components/buy-feature/index.vue'
import BuyEquity from './components/buy-rights/equity.vue'
import BuyStorage from './components/buy-storage/index.vue'
import BuySeat from './components/buy-seat/index.vue'

import LimitModal from './components/buy-feature/limit-modal.vue'

import type {
  ORDER_BEHAVIOR,
  ORDER_TYPE,
  RIGHTS_FEATURE,
} from '~/api/interface/rights'
import { showContact } from '~/hooks/useModal/modals/contact'
import { useEmptyModal } from '~/hooks/useModal/modals/empty'
import { USER_LEVEL_KEY, type UserInfo } from '~/api/interface'
import {
  getOrderClientRemainedBuyCreditCoinsCount,
  getRightsCreditCoinsPackage,
} from '~/api'

export const useShowPaymentEquity = () =>
  useState('showPaymentEquity', () => false)
/**
 *
 * 套餐购买/续费
 */
export const usePaymentEquity = (props: {
  title: string
  isRenew?: boolean // 是否续费，默认否
  userInfo: UserInfo
  rightsType: USER_LEVEL_KEY
  behavior: ORDER_BEHAVIOR
  order_type: ORDER_TYPE
}) => {
  const { $t } = useNuxtApp()
  const showPaymentEquity = useShowPaymentEquity()

  if (showPaymentEquity.value) {
    return
  }

  showPaymentEquity.value = true

  const onCancel = () => {
    model.destroy()
    showPaymentEquity.value = false
  }

  const isPersonal = [
    USER_LEVEL_KEY.PERSONAL,
    USER_LEVEL_KEY.PERSONAL_LITE,
  ].includes(props.rightsType)

  const title = isPersonal ? $t('ge-ren-ban') : props.title

  const width = (() => {
    if (isPersonal) {
      return 808
    }
    return 1135
  })()

  const patchedTitle =
    title + (props.isRenew ? $t('xu-fei-tao-can') : $t('gou-mai-tao-can'))

  const model = useEmptyModal({
    closable: false,
    width,
    onCancel,
    content: <BuyEquity {...props} title={patchedTitle} onCancel={onCancel} />,
  })
}

/**
 * 加购功能
 */
export const useAddFeature = async (props: {
  title: string
  user_info?: UserInfo
  feature_type: RIGHTS_FEATURE
  behavior: ORDER_BEHAVIOR
  order_type: ORDER_TYPE
}) => {
  const { $t } = useNuxtApp()
  // 需要根据账号类型进行判断：个人体验版和团队体验版是不能做加购的，企业标准版和企业旗舰版是不能线上加购的，需要商务介入
  // 团队入门版是有加购上限的，到达加购上限也是不能加购的

  // 是否允许加购言币
  if (!props.user_info?.rights_record.allow_add_coin) {
    const text = h(
      'a',
      { class: 'ml-[50px]', onClick: () => showContact() },
      $t('lian-xi-wo-men')
    )
    // 入门版
    const isTeam =
      Number(props.user_info?.rights_type) === USER_LEVEL_KEY.TEAM_LIGHT

    return message.info({
      content: h('div', [
        isTeam
          ? $t('yan-bi-bu-zu-qing-lian-xi-wo-men')
          : $t('yan-bi-bu-zu-qing-lian-xi-nin-de-shang-wu-fu-ze-ren'),
        text,
      ]),
      duration: 3,
    })
  }

  // 团队入门版的天选逻辑
  if (props.user_info?.rights_type === USER_LEVEL_KEY.TEAM_LIGHT) {
    const res1 = await getOrderClientRemainedBuyCreditCoinsCount()
    const res2 = await getRightsCreditCoinsPackage({
      many: '1',
      rights_type: props.user_info.rights_type!,
    })
    const remained_credit_coins = res1.data?.remained_credit_coins
    let isBuyable = true

    if (Number.isInteger(remained_credit_coins)) {
      isBuyable = (res2.data || []).some(
        (v) => v.total_credit_coins <= remained_credit_coins!
      )
    }

    if (!isBuyable) {
      const m = useEmptyModal({
        closable: false,
        width: 420,
        content: <LimitModal onClose={() => m.destroy()}></LimitModal>,
      })
      return
    }
  }

  const onCancel = () => {
    model.destroy()
  }

  const model = useEmptyModal({
    closable: false,
    width: 810,
    content: h(
      BaseContainer,
      { onCancel, title: props.title, closeRefresh: true },
      () => [h(BuyFeature, { ...props, onCancel })]
    ),
  })
}

/**
 * 联系客服
 */
export function useCustomerService() {
  showContact()
}

/**
 * 加购存储空间
 */
export const useAddStorage = (props: {
  title: string
  user_info?: UserInfo
  feature_type: RIGHTS_FEATURE
  behavior: ORDER_BEHAVIOR
  order_type: ORDER_TYPE
}) => {
  const onCancel = () => {
    model.destroy()
  }
  const model = useEmptyModal({
    closable: false,
    width: 758,
    content: h(
      BaseContainer,
      { onCancel, title: props?.title, closeRefresh: true },
      () => [h(BuyStorage, props)]
    ),
  })
}

/**
 * 弹出加购席位的modal
 *
 * @returns model实例
 */
export const useAddSeats = () => {
  const { $t } = useNuxtApp()
  const onCancel = () => {
    model.destroy()
  }
  const model = useEmptyModal({
    closable: false,
    width: 758,
    content: h(
      BaseContainer,
      { onCancel, title: $t('jia-gou-xi-wei'), closeRefresh: true },
      () => [h(BuySeat)]
    ),
  })
}
